import React from 'react'
//! Styles
import './overlay.style.css'

function Overlay({ openDetail, setOpenDetail }) {
  return (
    <div 
        className={openDetail ? "ovl-container show" : "ovl-container close"}
        onClick={() => {
            setOpenDetail(false)
            document.querySelector('body').style.overflow = 'scroll';
        }}
    >
    </div>
  )
}

export default Overlay